import React from "react"
import { Breadcrumb } from "react-bootstrap"

export const BreadCrumb = ({ label }) => {
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
        {label && <Breadcrumb.Item>{label}</Breadcrumb.Item>}
      </Breadcrumb>
    </div>
  )
}
